import { Card, CardBody } from '@chakra-ui/react'
import React from 'react'
import TaskContent from './TaskContent'

interface Props {
  onCreated(taskId: string): void
  onCancel(): void
}

// A project filled in inside a tension, during a meeting (#123): a card of the
// activity stream, like a next step (NextStepInlineForm, same margins), rather
// than a window over the meeting. Same form as the window — one
// implementation, two settings. Role and member start empty (#123 recette):
// the tension's role is rarely the one carrying the project.
export default function TaskInlineForm({ onCreated, onCancel }: Props) {
  return (
    <Card mt={6} mb={4} mx={5} variant="activity">
      <CardBody>
        <TaskContent
          compact
          onCreate={onCreated}
          onClose={onCancel}
        />
      </CardBody>
    </Card>
  )
}
